/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 27/7/2021
 * @Example
 */


export const types = {
    W06F0010_LOAD_FORM: 'W06F0010_LOAD_FORM',
}

export function loadForm(params, cb) {
    return {
        type: types.W06F0010_LOAD_FORM,
        params,
        cb
    }
}